var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', { bordered: _vm.bordered, 'light-bordered': _vm.lightBordered }]},[_vm._t("header"),_vm._t("body"),_vm._t("extra"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }